module.exports = __webpack_public_path__ + "img/19.b5acff0f.jpg";